import { CircularProgress } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { makeStyles } from "@mui/styles";
import { useSnackbar } from "notistack";
import { s3baseUrl } from "src/config/config";
import { helping_video_Category_listing_api } from "src/DAL/HelpingVideos/AdminHelpingVideosCategory";
import RecordNotFound from "src/components/GeneralComponents/RecordNotFound";
import { useQuery } from "@tanstack/react-query";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

export default function HelpingVideosCategory() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const { data: videosCategory = [], isLoading } = useQuery({
    queryKey: ["helpingVideosCategories"],
    queryFn: async () => {
      const postData = {
        search: "",
        type: 1,
      };
      const result = await helping_video_Category_listing_api(postData);
      if (result?.code !== 200) {
        throw new Error(result?.message);
      }
      return result;
    },
    select: (result) => result?.helping_video_categories || [],
    onError: (error) => {
      enqueueSnackbar(error?.message, { variant: "error" });
    },
  });

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-lg-12 col-sm-12">
          <h2>Helping videos Category</h2>
        </div>

        {videosCategory.length > 0 ? (
          videosCategory.map((value, index) => {
            return (
              <div className="col-lg-4 col-md-4 col-sm-12 mb-4" key={index}>
                <div
                  className="card mt-4 pods-cards-shadow cursor h-100"
                  onClick={() =>
                    navigate(
                      `/helping_videos_category/helping-videos/${value._id}`,
                      {
                        state: value,
                      },
                    )
                  }
                >
                  <img
                    src={s3baseUrl + value?.image?.thumbnail_1}
                    className="card-img-top pods-image"
                    alt="Programme"
                  />
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12">
                        <h3 className="h2-heading">{value.title}</h3>
                      </div>

                      <div className="col-2 menu-option"></div>
                    </div>
                    <p className="programme-card-desc">{value.description}</p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <RecordNotFound title={"Categories Not Found"} />
        )}
      </div>
    </div>
  );
}
